import { RouteDefinition } from "@solidjs/router";
import { lazy } from "solid-js";

export const userRoutes: RouteDefinition[] = [
  {
    path: "user/:id/*",
    children: [
      {
        path: "/",
        component: lazy(() => import("../components/user/UserProfile.js")),
      },
    ],
  },
];
